// extracted by mini-css-extract-plugin
export var centered = "_q-6";
export var flexible = "_q-5";
export var footer = "_q-k";
export var footerBorder = "_q-l";
export var header = "_q-c";
export var headerBorder = "_q-d";
export var headerDefault = "_q-g";
export var headerMedium = "_q-h";
export var headerPadding = "_q-e";
export var iconAndTitle = "_q-f";
export var large = "_q-4";
export var largePadding = "_q-a";
export var medium = "_q-3";
export var mediumPadding = "_q-9";
export var modal = "_q-0";
export var modalContainer = "_q-b";
export var noPadding = "_q-7";
export var skinny = "_q-1";
export var small = "_q-2";
export var smallPadding = "_q-8";
export var subtitle = "_q-j";
export var title = "_q-i";